import { Box, BoxProps, Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { MGPrisIconWhite } from '@shared/custom-icons';
import { forwardRef } from 'react';

interface Props extends BoxProps {
  orgType: OrgUnitType;
  backgroundColor?: string;
}

export const MGPrisLogo = forwardRef<unknown, Props>(
  ({ orgType, backgroundColor, ...props }, ref) => {
    const t = useAppTFunction();
    return (
      <Box position="relative" height="100%" ref={ref} {...props}>
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            left: 102,
            zIndex: 1,
            color: 'common.white',
            fontSize: '42px',
          }}
        >
          <MGPrisIconWhite fontSize="inherit" />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          sx={{
            width: '120px',
            height: '100%',
            backgroundColor: backgroundColor || 'primary.main',
            transform: 'skew(-43deg)',
            marginLeft: '4rem',
            marginRight: '4rem',
          }}
        >
          <Stack
            sx={(theme) => ({
              fontFamily: 'cursive',
              transform: 'skew(43deg) rotate(-47.5deg)',
              position: 'fixed',
              width: 80,
              right: -50,
              color: backgroundColor || 'primary.main',
              ...(!backgroundColor &&
                theme.applyStyles('dark', { color: theme.vars.palette.primary.light })),
            })}
          >
            <Typography variant="body2" fontSize={14} align="center">
              {orgType === OrgUnitType.RETAIL_BRAND && 'MASTER'}
              {orgType === OrgUnitType.RETAIL_LOCATION_LIGHT && 'LIGHT'}
              {orgType === OrgUnitType.RETAIL_LOCATION_LIGHT_PLUS && 'LIGHT PLUS'}
              {orgType === OrgUnitType.WHOLESALE_LOCATION &&
                t('app.orgUnit.wholesaler').toUpperCase()}
              {orgType === OrgUnitType.WHOLESALE_PRICE_LIST &&
                t('app.orgUnit.priceList.singular').toUpperCase()}
            </Typography>
          </Stack>
        </Box>
      </Box>
    );
  }
);
